import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { apiErrorMessage, useForgotPassword } from '../lib/api'
import { AuthShell } from '../components/AuthShell'

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const m = useForgotPassword()
  const submit = (e: FormEvent) => { e.preventDefault(); m.mutate({ email }) }

  return (
    <AuthShell>
      <div className="auth-card">
        <div className="auth-card__header">
          <h1 className="auth-card__title">Reset your password</h1>
          <p className="auth-card__subtitle">Enter your email and we'll send you a secure reset link. The link is valid for 30 minutes.</p>
        </div>

        <form className="auth-card__body" onSubmit={submit}>
          <div className="field">
            <label className="field__label" htmlFor="forgot-email">Email address</label>
            <input id="forgot-email" className="field__input" type="email" required autoComplete="email"
              placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>

          {m.isError && (
            <div className="auth-card__error" role="alert" style={{ display: 'flex' }}>
              {apiErrorMessage(m.error)}
            </div>
          )}
          {m.isSuccess && (
            <div role="status" style={{ background: 'var(--color-success-subtle)', color: 'var(--color-success-text)',
              padding: 'var(--space-3) var(--space-4)', borderRadius: 'var(--radius-md)', fontSize: 'var(--text-sm)' }}>
              If an account exists, a reset link has been sent.
            </div>
          )}

          <button type="submit" className="btn btn--primary auth-card__submit" disabled={m.isPending}>
            {m.isPending ? 'Sending…' : 'Send reset link'}
          </button>
        </form>

        <div className="auth-card__footer">
          Remembered it?
          <Link to="/login" className="auth-card__footer-link">Back to sign in</Link>
        </div>
      </div>
    </AuthShell>
  )
}
